












































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import { Storage } from "aws-amplify";
import { NotificationEventBus } from "@/EventBus";

@Component
export default class FileSelector extends Vue {

    @Prop()
    id!: string;

    @Prop()
    label!: string;

    @Prop()
    description!: string;

    @Prop()
    keyPrefix!: string;

    @Prop()
    dataValue!: string;

    @Prop()
    hideDetails!: boolean;

    @Prop({ default: 30000000 })
    sizeMax!: number;

    @Prop({ default: false })
    outlined!: boolean;

    @Prop({ default: '', type: String })
    maxWidth!: string;

    rules = [
        (value: any) => !value || value.size < this.sizeMax || 'Unable to upload file of that size. Max size is ' + this.sizeMax / 1000000 + 'MBs',
    ];

    file: File | null = null;

    value: any = null;
    previousFileText: any = null;

    private fileLink: any = null;
    private currentFileLink: any = null;

    $refs!: {
        fileInput: HTMLFormElement
    };

    mounted() {
        this.previousFileText = this.getFileTextViaKey(this.dataValue);
        this.getFileLink();
    }


    @Watch('id')
    onIdChange(newVal: any, oldVal: any) {
        if (!newVal) {
            this.previousFileText = null;
            this.fileLink = null;
        } else {
            this.previousFileText = this.getFileTextViaKey(this.dataValue);
            this.fileLink = this.getFileLink();
        }
    }


    @Watch('dataValue')
    onDataValueChange(newVal: any, oldVal: any) {
        // this.value = this.dataValue;
        if (!oldVal && newVal) {
            this.previousFileText = this.getFileTextViaKey(this.dataValue);
            this.fileLink = this.getFileLink();
        } else if (!newVal) {
            this.previousFileText = null;
            this.fileLink = null;
            this.value = null;
            this.file = null;
        }

    }

    get fileText() {
        return this.getFileTextViaKey(this.value);
    }

    getFileTextViaKey(key: string) {
        if (key) {
            let splits = key.split('/')
            return splits[splits.length - 1]
        }
    }

    fileChange(file: any) {
        console.log(file)
        if (file) {
            if (!this.$refs.fileInput.validate()) {
                return
            }

            if (file.size > this.sizeMax) {
                NotificationEventBus.emitFailedMessage({message: 'Unable to upload file of that size. Max size is ' + this.sizeMax / 1000000 + 'MBs'})
            }

            let fileName = file.name;
            let lastIndexOfPeriod = fileName.lastIndexOf(".");
            if (lastIndexOfPeriod > 0) {
                let fileNameWithoutExtension = fileName.substring(0, lastIndexOfPeriod);
                let extension = fileName.substring(lastIndexOfPeriod);
                fileName = fileNameWithoutExtension + '-' + new Date().getTime() + extension
            } else {
                fileName = fileName + '-' + new Date().getTime()
            }
            let key = `${this.keyPrefix}/${fileName}`;

            Storage.put(key, file)
                .then((result: any) => {
                    this.value = result.key;
                    this.$emit("value-updated", this.value)
                    Storage.get(result.key)
                        .then(f => this.currentFileLink = f);
                });
        }
    }

    getFileLink() {
        let key = this.dataValue;
        if (key) {
            Storage.get(key)
                .then(result => {
                    this.fileLink = result;
                });
        }
    }


}
